import React from "react";
import NewsTab from "../NewsTab";
import Home from "../Home";
import "../HomePage.css";

function HomePage() {
  return (
    <>
      <NewsTab />
      <Home />
    </>
  );
}

export default HomePage;
